const chain = [
  'Оценили',
  'Определили дефициты',
  'Сформировали план',
  'Обучили',
  'Применили',
  'Получили обратную связь',
  'Повторно оценили',
];

const tools = [
  'корпоративное обучение',
  'индивидуальное обучение',
  'наставничество',
  'коучинг',
  'развивающие задачи',
  'участие в проектах',
  'кадровый резерв',
  'управленческие программы',
  'самостоятельное развитие',
];

export default function FromAssessmentToDevelopment() {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          От оценки к развитию
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center max-w-3xl mx-auto mb-6 leading-relaxed">
          Оценка сама по себе ничего не меняет.
        </p>

        <div className="bg-teal-50 rounded-2xl border border-teal-100 p-6 md:p-10 mb-10">
          <div className="flex flex-col items-center gap-3">
            <div className="flex flex-wrap items-center justify-center gap-2 md:gap-3">
              {chain.map((step, i) => (
                <div key={i} className="flex items-center gap-2 md:gap-3">
                  <div className="bg-teal-600 text-white px-4 py-2.5 rounded-lg font-semibold text-xs md:text-sm whitespace-nowrap">
                    {step}
                  </div>
                  {i < chain.length - 1 && (
                    <i className="ri-arrow-right-line text-teal-500 text-lg"></i>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-start">
          <div>
            <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-4">
              Главная ценность оценки — не отчёт
            </h3>
            <p className="text-sm md:text-base text-gray-600 leading-relaxed mb-4">
              Главная ценность оценки — возможность понять, что именно делать дальше. Отчёт без следующих шагов остаётся просто информацией, которая не меняет работу сотрудников и результат бизнеса.
            </p>
            <p className="text-sm md:text-base text-gray-600 leading-relaxed">
              Поэтому оценка всегда связывается с конкретными действиями по развитию, а не завершается презентацией результатов.
            </p>
          </div>

          <div className="bg-gray-50 rounded-2xl border border-gray-100 p-6 md:p-8">
            <h3 className="text-lg md:text-xl font-bold text-gray-900 mb-4">
              После оценки для разных сотрудников могут использоваться
            </h3>
            <div className="flex flex-wrap gap-2">
              {tools.map((t, i) => (
                <span key={i} className="bg-white border border-gray-200 text-gray-700 px-3 py-1.5 rounded-full text-xs font-medium">
                  {t}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}